function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import JSZip from 'jszip';
import _ from 'lodash';
import { saveAs } from 'file-saver';
import { loadDigitalOrderDisplayDetails } from 'researcher/digital-orders/actions';
import { recordOrderCompletion } from 'researcher/helpers/gtm';
import { convertFormDataToCertificateUpdateRequest } from 'shared/view/certificate-conversion-service';
import { convertOrderSearchRequestToJson } from 'shared/view/order-conversion-service';
import { convertServiceOptionsToJson } from 'shared/view/service-option-conversion-service';
import { convertTimestampToDate } from 'shared/view/generics-conversion-service';
import * as c from './constants';
var processOrderRequest = function processOrderRequest(dispatch, promiseFn) {
  var reset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return promiseFn.then(function (response) {
    var json = convertOrderSearchRequestToJson(response);
    dispatch({
      type: c.ORDERS_LOADED,
      orders: _.keyBy(json.orders, 'externalId'),
      orderIds: json.orders.map(function (s) {
        return s.externalId;
      }),
      pagination: json.pagination,
      reset: reset
    });
    return {
      orders: json.orders
    };
  });
};
export var fetchOrders = function fetchOrders(_ref) {
  var xid = _ref.xid,
    orderTitle = _ref.orderTitle,
    from = _ref.from,
    to = _ref.to,
    page = _ref.page;
  var reset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function (dispatch, getState, _ref2) {
    var application = _ref2.application;
    dispatch({
      type: c.ORDERS_REQUESTED
    });
    return processOrderRequest(dispatch, dispatch(application.get('/api/order/search', {
      xid: xid,
      orderTitle: orderTitle,
      from: from,
      to: to,
      page: page
    })), reset);
  };
};
export var fetchOrderCertificate = function fetchOrderCertificate(xid) {
  return function (dispatch, getState, _ref3) {
    var application = _ref3.application;
    return processOrderRequest(dispatch, dispatch(application.get('/api/order/search', {
      xid: xid,
      from: '',
      to: '',
      page: 1
    })));
  };
};
export var saveOrder = function saveOrder(orderUpdateRequest) {
  return function (dispatch, getState, _ref4) {
    var application = _ref4.application;
    return dispatch(application.put("/api/order/".concat(orderUpdateRequest.orderDetails.externalId, "/save"), orderUpdateRequest)).then(function (json) {
      var error = json.error,
        orderDetails = json.orderDetails;
      if (error) {
        dispatch(application.addMessage({
          type: 'error',
          message: error.error
        }));
      } else {
        dispatch({
          type: c.ORDER_UPDATED,
          order: _objectSpread(_objectSpread({}, orderDetails), {}, {
            deadline: convertTimestampToDate(orderDetails.deadline)
          })
        });
      }
      return json;
    });
  };
};
export var updateCertificate = function updateCertificate(code, externalId, formData) {
  return function (dispatch, getState, _ref5) {
    var application = _ref5.application;
    dispatch({
      type: c.CERTIFICATE_UPDATE_REQUESTED
    });
    var certificateUpdateRequest = convertFormDataToCertificateUpdateRequest(formData, {
      externalId: externalId,
      code: code
    });
    return dispatch(application.put("/api/certificate/save/".concat(code), certificateUpdateRequest)).then(function (json) {
      var error = json.error || null;
      var certificate = json.certificateDetails;
      dispatch({
        type: c.CERTIFICATE_UPDATED,
        certificate: error ? null : certificate
      });
      if (error) {
        dispatch(application.addMessage({
          type: 'error',
          message: error
        }));
      } else {
        dispatch(application.addMessage({
          type: 'success',
          message: 'certificate-details-updated'
        }));
      }
      return {
        error: error,
        certificate: certificate
      };
    });
  };
};
export var updateEmailNotificationSettings = function updateEmailNotificationSettings(externalId, formData, callback) {
  return function (dispatch, getState, _ref6) {
    var application = _ref6.application;
    dispatch({
      type: c.EMAIL_NOTIFICATION_UPDATE_REQUESTED
    });
    return dispatch(application.post("/api/order/".concat(externalId, "/email-notifications"), formData)).then(function (json) {
      dispatch({
        type: c.EMAIL_NOTIFICATION_UPDATED
      });
      callback(!json.error);
      if (!json.error) {
        dispatch(application.addMessage({
          type: 'success',
          message: 'Thank you for the additional information regarding your order.'
        }));
      }
      return json;
    });
  };
};
export var loadPaymentInformation = function loadPaymentInformation(externalId) {
  var shouldRecordOrderCompletion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function (dispatch, getState, _ref7) {
    var application = _ref7.application;
    return dispatch(application.get("/api/order/".concat(externalId, "/payment"))).then(function (json) {
      if (_.isEmpty(json.order)) {
        return null;
      }
      if (shouldRecordOrderCompletion) {
        recordOrderCompletion(json.order);
      }
      dispatch({
        type: c.ORDER_PAYMENT_INFORMATION_LOADED,
        order: json.order
      });
      return json.order;
    });
  };
};
export var downloadFile = function downloadFile(externalId, fileKey, rawDownloadProgress) {
  return function (dispatch, getState, _ref8) {
    var application = _ref8.application;
    return dispatch(application.req({
      url: "/api/order/".concat(externalId, "/deliverables/").concat(fileKey),
      method: 'get',
      responseType: 'blob',
      timeout: 0,
      transformResponse: [function (data) {
        return new Blob([data]);
      }],
      validateStatus: function validateStatus(status) {
        return status === 200;
      },
      onDownloadProgress: function onDownloadProgress(progressEvent) {
        var downloadProgress = rawDownloadProgress;
        downloadProgress[fileKey].bytesReceived = progressEvent.loaded;
        var bytesReceived = _.reduce(downloadProgress, function (sum, file) {
          return sum + file.bytesReceived;
        }, 0);
        var bytesTotal = _.reduce(downloadProgress, function (sum, file) {
          return sum + file.bytesTotal;
        }, 0);
        var percent = Math.floor(bytesReceived / bytesTotal * 100);
        dispatch({
          type: c.DOWNLOAD_URL_REQUEST_PROGRESS,
          externalId: externalId,
          percent: percent
        });
      }
    }));
  };
};
export var getDownloadUrl = function getDownloadUrl(externalId) {
  return function (dispatch, getState, _ref9) {
    var application = _ref9.application;
    dispatch({
      type: c.DOWNLOAD_URL_REQUESTED,
      externalId: externalId
    });
    dispatch(application.get("/api/order/".concat(externalId, "/deliverables"))).then(function (json) {
      if (json.error) {
        dispatch(application.addMessage({
          type: 'error',
          message: 'generic-download-error'
        }));
      }
      var zip = new JSZip();
      var downloadProgress = {};
      json.files.forEach(function (file) {
        downloadProgress[file.key] = {
          bytesReceived: 0,
          bytesTotal: file.size
        };
        zip.file(file.path, dispatch(downloadFile(externalId, file.key, downloadProgress)), {
          binary: true
        });
      });
      zip.generateAsync({
        type: 'blob'
      }).then(function (content) {
        saveAs(content, "".concat(json.companyName, " Completed files ").concat(json.externalId, ".zip"));
        dispatch({
          type: c.DOWNLOAD_URL_REQUEST_COMPLETE,
          externalId: externalId
        });
      }).catch(function () {
        return dispatch({
          type: c.DOWNLOAD_URL_REQUEST_COMPLETE,
          externalId: externalId
        });
      });
      return json;
    }).catch(function () {
      return dispatch({
        type: c.DOWNLOAD_URL_REQUEST_COMPLETE,
        externalId: externalId
      });
    });
  };
};
export var loadDashboard = function loadDashboard() {
  return function (dispatch) {
    dispatch(loadDigitalOrderDisplayDetails());
  };
};
export var loadServices = function loadServices(externalId) {
  return function (dispatch, getState, _ref10) {
    var application = _ref10.application;
    return dispatch(application.get("/api/order/".concat(externalId, "/services"))).then(function (json) {
      var _convertServiceOption = convertServiceOptionsToJson(json),
        serviceOptions = _convertServiceOption.serviceOptions;
      dispatch({
        type: c.SERVICES_LOADED,
        externalId: externalId,
        serviceOptions: serviceOptions
      });
    });
  };
};